import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.mobileComparisionList = new Swiper('.mobile-comparision-list', {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 30,
    });
    console.log('sads');
  }
  close() {
    const elem = document.getElementById('comparable-cars');
    elem.style.display = 'none';
  }
}